export enum QueryKey {
  listProducts = 'listProducts',
  listPartnerships = 'listPartnerships',
  listAffiliations = 'listAffiliations',
  updateReceiverStatus = 'updateReceiverStatus',
  createProduct = 'createProduct',
  listEventTickets = 'listEventTickets',
  listEvents = 'listEvents',
}
